import { useStorage } from "@vueuse/core";

export default function useAuthToken() {
  const storage = useStorage('nibOnlineSubmissions_token', {token: ""})

  const storeToken = (token: string) => {
    storage.value.token = token
  };

  const getToken = () => {
    return storage.value.token
  };

  const removeToken = () => {
    storage.value.token = ""
  };

  const isLoggedIn = () => {
    const token = getToken();

    return token ? true : false;
  };

  return {
    storeToken,
    getToken,
    removeToken,
    isLoggedIn
  };
}
